export const POSTS_FORM_TYPE = {
  POST: 1,
  EVENT: 2,
  OFFER: 3,
  ALERT: 4
};

export const POSTS_CALL_TO_ACTION_TYPE = {
  BOOK: "book",
  ORDER: "order",
  SHOP: "shop",
  LEARN_MORE: "learnMore",
  SIGN_UP: "signUp",
  CALL: "call"
};

export const POSTS_REPORT_INSIGHTS = {
  CLICKS_COUNT: "LOCAL_POST_ACTIONS_CALL_TO_ACTION",
  VIEWS_COUNT: "LOCAL_POST_VIEWS_SEARCH"
};

export const POST_STATUS = {
  PENDING: 1,
  COMPLETED: 2,
  FINISHED_WITH_PROBLEMS: 3
};

export const POST_BY_FACILITY_STATUS = {
  PENDING: 1,
  IN_PROGRESS: 2,
  OK: 3,
  FAILED: 4
};

export const POST_TYPE = {
  STANDARD: "STANDARD",
  EVENT: "EVENT",
  OFFER: "OFFER",
  ALERT: "ALERT"
};

export const POST_ACTION = {
  CREATE: 1,
  DELETE: 2
};
